import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import styles from './ContentList.module.css';
import {ItemCard} from '../ItemCard/ItemCard';
import {IFile, IFolder} from '../../../types/knowledgeBase.types';
import {KNOWLEDGE_BASE_ENDPOINTS} from '../../../services/network/endpoints';
import {API_URL_V2} from '../../../config';

interface ContentListProps {
    folderId?: string;
    isRootLevel: boolean;
    folders?: IFolder[];
    files?: Array<IFile | IFolder> | undefined;
    isAdmin: boolean;
}

export const ContentList: React.FC<ContentListProps> = ({
                                                            folderId,
                                                            isRootLevel,
                                                            folders = [],
                                                            files = [],
                                                            isAdmin
                                                        }) => {
    const navigate = useNavigate();
    const handleItemClick = (item: IFolder | IFile) => {
        if ('folderId' in item) { // это файл
            if (item.type === "link") {
                window.open(item.path, '_blank');
            }  else {
                const fileUrl = `${API_URL_V2}${KNOWLEDGE_BASE_ENDPOINTS.GET_FILE}/${item._id}`;
                window.open(fileUrl, '_blank');
            }
        } else { // это папка
            const basePath = isAdmin
                ? '/administrator/cabinet/knowledge-base'
                : '/user/cabinet/knowledge-base';
            const newPath = `${basePath}/${item._id}`;
            navigate(newPath);
        }
    };

    const isEmpty = isRootLevel ? folders.length === 0 : folders.length === 0 && files.length === 0;



    if (isEmpty) {
        return (
            <div className={styles.emptyState}>
                <p className={styles.emptyMessage}>
                    {isRootLevel
                        ? "База знаний пока пуста"
                        : "В этой папке пока нет элементов"
                    }
                </p>
            </div>
        );
    }

    return (
        <div className={styles.contentWrapper}>
            {/* В корневой директории показываем только папки */}
            {isRootLevel && folders.map(folder => {
                const coverImageUrl = folder.coverImage ? `${API_URL_V2}${KNOWLEDGE_BASE_ENDPOINTS.GET_FILE}/${folder.coverImage}` : null;
                return (
                    <ItemCard
                        key={folder._id}
                        type="folder"
                        name={folder.name}
                        id={folder._id}
                        isAdmin={isAdmin}
                        onClick={() => handleItemClick(folder)}
                        pathCover={coverImageUrl}
                    />
                );
            })}

            {/* В подпапках показываем папки и файлы */}
            {!isRootLevel && (
                <>
                    {files?.map(item => {
                        // Проверяем, является ли элемент файлом или папкой
                        if ('folderId' in item) { // это файл
                            const coverImageUrl = item.thumbnail ? `${API_URL_V2}${KNOWLEDGE_BASE_ENDPOINTS.GET_FILE}/${item.thumbnail}` : null;

                            return (
                                <ItemCard
                                    key={item._id}
                                    type="file"
                                    name={item.name}
                                    originalName={item.originalName}
                                    id={item._id}
                                    isAdmin={isAdmin}
                                    onClick={() => handleItemClick(item)}
                                    file={item}
                                    pathCover={coverImageUrl}
                                />
                            );
                        } else { // это папка
                            const coverImageUrl = item.coverImage ? `${API_URL_V2}${KNOWLEDGE_BASE_ENDPOINTS.GET_FILE}/${item.coverImage}` : null;
                            return (
                                <ItemCard
                                    key={item._id}
                                    type="folder"
                                    name={item.name}
                                    id={item._id}
                                    isAdmin={isAdmin}
                                    onClick={() => handleItemClick(item)}
                                    pathCover={coverImageUrl}
                                />
                            );
                        }
                    })}
                </>
            )}
        </div>
    );
};
